'use strict';

function CompanyPublicationPlantService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/plants/:plantId', {}, {
    'update': {
      method: 'PUT'
    },
    'queryDeliveries': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/plants/:plantId/deliveries',
      method: 'GET',
      isArray: true
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationPlantService', ['$resource', 'config', CompanyPublicationPlantService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/plant/CompanyPublicationPlantService.js
// module id = 31
// module chunks = 0